import req from './request'

const DEFAULT_ENDPOINTS = {
    parks: '/dashboard/ai/parks',
    parksReference: '/dashboard/ai/parks/reference'

}
export default {
    parks(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.parks, param)
    },
    parksReference(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.parksReference, param)
    },
}